// FUVIKA — scripts de las secciones fp-*
document.addEventListener('DOMContentLoaded', function () {
  initRevelado();
  initFaqAcordeon();
  initGaleriaProducto();
  initSelectorVariantes();
  initContadores();
});

function initRevelado() {
  var els = document.querySelectorAll('.fp-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('fp-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-fp-delay') || 0;
        setTimeout(function () { entry.target.classList.add('fp-visible'); }, Number(delay));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function initFaqAcordeon() {
  var items = document.querySelectorAll('.fp-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var pregunta = item.querySelector('.fp-faq-pregunta');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('fp-faq-abierto');
      items.forEach(function (i) { i.classList.remove('fp-faq-abierto'); });
      if (!abierto) item.classList.add('fp-faq-abierto');
    });
  });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-fp-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-fp-imagen-principal]');
  var minis = galeria.querySelectorAll('[data-fp-miniatura]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-fp-src');
      var srcset = mini.getAttribute('data-fp-srcset');
      if (!src) return;
      principal.src = src;
      if (srcset) principal.srcset = srcset;
      minis.forEach(function (m) { m.classList.remove('fp-mini-activa'); });
      mini.classList.add('fp-mini-activa');
    });
  });
}

function initSelectorVariantes() {
  var wrap = document.querySelector('[data-fp-variantes]');
  if (!wrap) return;
  var dataEl = document.querySelector('[data-fp-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var inputId = document.querySelector('[data-fp-variant-id]');
  var precioEl = document.querySelector('[data-fp-precio]');
  var precioTachadoEl = document.querySelector('[data-fp-precio-tachado]');
  var botonComprar = document.querySelector('[data-fp-boton-comprar]');
  var etiquetaDisponibilidad = document.querySelector('[data-fp-disponibilidad]');

  function opcionesSeleccionadas() {
    var seleccion = [];
    wrap.querySelectorAll('[data-fp-opcion]').forEach(function (grupo) {
      var activo = grupo.querySelector('.fp-opcion-activa');
      seleccion.push(activo ? activo.getAttribute('data-fp-valor') : null);
    });
    return seleccion;
  }

  function encontrarVariante() {
    var seleccion = opcionesSeleccionadas();
    return variantes.find(function (v) {
      return v.opciones.every(function (val, idx) { return val === seleccion[idx]; });
    });
  }

  function formatoDinero(centavos) {
    return (centavos / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD' });
  }

  function actualizar() {
    var variante = encontrarVariante();
    if (!variante) return;
    if (inputId) inputId.value = variante.id;
    if (precioEl) precioEl.textContent = formatoDinero(variante.precio);
    if (precioTachadoEl) {
      if (variante.precioComparado && variante.precioComparado > variante.precio) {
        precioTachadoEl.textContent = formatoDinero(variante.precioComparado);
        precioTachadoEl.style.display = '';
      } else {
        precioTachadoEl.style.display = 'none';
      }
    }
    if (botonComprar) {
      botonComprar.disabled = !variante.disponible;
      botonComprar.querySelector('[data-fp-boton-texto]').textContent = variante.disponible
        ? botonComprar.getAttribute('data-fp-texto-disponible')
        : botonComprar.getAttribute('data-fp-texto-agotado');
    }
    if (etiquetaDisponibilidad) {
      etiquetaDisponibilidad.textContent = variante.disponible ? etiquetaDisponibilidad.getAttribute('data-fp-texto-stock') : etiquetaDisponibilidad.getAttribute('data-fp-texto-agotado-corto');
      etiquetaDisponibilidad.classList.toggle('fp-stock-agotado', !variante.disponible);
    }
  }

  wrap.querySelectorAll('[data-fp-opcion-valor]').forEach(function (boton) {
    boton.addEventListener('click', function () {
      var grupo = boton.closest('[data-fp-opcion]');
      grupo.querySelectorAll('[data-fp-opcion-valor]').forEach(function (b) { b.classList.remove('fp-opcion-activa'); });
      boton.classList.add('fp-opcion-activa');
      actualizar();
    });
  });

  actualizar();
}

function initContadores() {
  var contadores = document.querySelectorAll('[data-fp-contador]');
  if (!contadores.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var destino = Number(el.getAttribute('data-fp-contador'));
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        el.textContent = Math.floor(progreso * destino).toLocaleString();
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = destino.toLocaleString();
      }
      requestAnimationFrame(paso);
      observer.unobserve(el);
    });
  }, { threshold: 0.4 });
  contadores.forEach(function (el) { observer.observe(el); });
}
